export default {
  ratePlanType: {
    STANDARD: 'Estándar',
    BAR: 'Mejor tarifa disponible',
    CORPORATE: 'Corporativa',
    MEMBER: 'Miembro',
    PACKAGE: 'Paquete',
    PROMOTIONAL: 'Promocional',
    OTA: 'OTA',
    WHOLESALE: 'Mayorista',
    NEGOTIATED: 'Negociada',
    MIXED: 'Tarifa combinada',
  },
} as const;
